export const set_stock_count_items = (stock_count_items) => {
    return {
        type: 'SET_STOCK_COUNT_ITEMS',
        stock_count_items
    };
}
